module.exports = __webpack_public_path__ + "img/drivers-active.0d361fc4.svg";